// extracted by mini-css-extract-plugin
export var box = "_9j-1";
export var checkboxRow = "_9j-8";
export var checked = "_9j-2";
export var descriptionSpacer = "_9j-a";
export var disabled = "_9j-3";
export var icon = "_9j-6";
export var input = "_9j-0";
export var labelSpacer = "_9j-9";
export var medium = "_9j-5";
export var small = "_9j-4";
export var text = "_9j-7";